import * as React from 'react';
import { IChannel, IDocument } from '../../../../../data/api/models';
import { get, isEmpty } from 'lodash';

interface ITermAndConditionsProps {
  documents?: IDocument[];
  channel?: IChannel;
}

export const TermsAndConditions = ({ documents = [], channel }: ITermAndConditionsProps) => {

  const conditionsAndPrivacy = () => {
    return (
      <div style={{ margin: '30px 0 30px 0' }}>
        By continuing you agree to the Terms and Conditions shown above, the <a
        href={'https://www.admiral.com/insurance/your-policy/conditions-of-use.php?&contentOnly=1&_ga=2.7793211.828839540.1508235797-2125578306.1459951786&_gac=1.217769634.1505922935.EAIaIQobChMI_rW5lpC01gIVzrztCh1dwA5aEAAYASAAEgJX9PD_BwE'}
        target={'_blank'}> conditions
        of use</a> and <a
        href={'https://www.admiral.com/your-privacy-and-security?&contentOnly=1&_ga=2.7793211.828839540.1508235797-2125578306.1459951786&_gac=1.217769634.1505922935.EAIaIQobChMI_rW5lpC01gIVzrztCh1dwA5aEAAYASAAEgJX9PD_BwE\n' +
          '\n'} target={'_blank'}>privacy statement</a>. You are also confirming that the summary of cover meets your needs.
      </div>
    )
  }

  if (!isEmpty(documents)) {

    const isAggregator = get(channel, 'channelType') === 'AGG';

    if (isAggregator) {
      return (
        <>
          <div style={{ margin: '30px 0 30px 0' }}>
            {conditionsAndPrivacy()}
          </div>
        </>
      )
    } else {

      return (
        <div>
          By continuing you are agreeing to the Terms and Conditions shown above and that the
          summary of cover meets your needs.
        </div>
      )
    }
  } else {
    return (
      <>
        {conditionsAndPrivacy()}
      </>
    )
  }


}
